/**
 * 费用减免 Modal FeeReduction
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 *
 **/
import React from "react";
import { Spin, Radio,InputNumber,Button,Popconfirm,message } from 'antd';
import Lang from '@components/Lang/Lang';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import EssaModal from '@components/EssaModal/EssaModal';
import {isEmpty,isEmptyObject} from "@utils/utils";
import TakeDeliveryAction from "../../TakeDelivery.action";

export default class ModalFeeReduction extends React.Component{
    static defaultProps = {
        deliveryOrderId:"",
        item:{

        },
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading:false,
            // 表单项
            show:false,
        }
    }
    /**
     * 打开
     * */
    showModal = (flag=true,type) => {
        this.setState({
            visible: flag,
            reductionPrice:"",
            type:""
        });
    };
    // 初始化
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    changeType(e){
        this.setState({
            type:e.target.value
        })
    }
    changePrice(value){
        this.setState({
            reductionPrice: value
        })
    }
    /**
     * 点击确认时 获取表单数据
     ***/
    handleOK(){
        const { deliveryOrderId } = this.props;
        const { type,reductionPrice } = this.state;
         // 0 不全免 1全免 ？
        if(type=="0"&&isEmpty(reductionPrice)){
            message.warning(Lang({id:"QingShuRuYouHuiJinE",default:"请输入优惠金额"}))
            return false
        }
        let data = {
            deliveryOrderId:deliveryOrderId,
            isAllReduction:Number(type),
        }
        this.loading(true);
        if(type=="0"){
            data["reductionPrice"] = reductionPrice;
        }
        const  sUrl = '/service/mg/whs/delivery/submit-fee-reduction';
        TakeDeliveryAction.post(data,sUrl).then((res)=>{
            const resData =res.data;
            this.loading(false)
            const { success, valid} = resData;
            if(success&&valid){
                this.showModal(false);
                this.props.refreshPage()
                message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
            }else if(resData.message){
                message.warning(resData.message);
            }else {
                message.warning(Lang({id:"BaoCunShiBai"}));
            }
        })

    }
    componentWillMount(){
        const { reductionList=[] } = this.props; // 已减免列表
        const hasPayAllObj = reductionList.find(pay=>pay.isAllReduction==1);
        if(hasPayAllObj&&hasPayAllObj.isAllReduction){
            this.setState({
                isAllReduction : true
            })
        }
    }
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    };
    componentWillUnmount() {

    }
    render() {
        const { visible, loading, type,isAllReduction} = this.state;
        const {item,} = this.props;
         return (<>
             {isAllReduction?<AuthBtn className={"btnDisabled ml_8"}
                                      tips = {Lang({id:"YiQuanMianFeiYong",default:"已全免费用"})}
                                      title={Lang({id:"JianMianFeiYong",default:"减免费用"})}
             />:<AuthBtn auth={"Take-Delivery-Fee-Reduction"}// 提货的减免费用权限
                      className={"ml_8"}
                      title={Lang({id:"JianMianFeiYong",default:"减免费用"})}
                      onClick={()=>this.showModal(true)} />}
             <EssaModal title={Lang({id:"JianMianFeiYong",default:"减免费用"})}
                        open={visible}
                        closable={false}
                        footer={null}
                        width={500}
                        onCancel={()=>this.showModal(false)}
                        onOk={()=>this.handleOK()} >
                <Spin spinning={loading}>
                    <div className={"mt_14"}>
                        {/* 0 不全免 1全免 ？ */}
                        <Radio.Group value={type} onChange={(e)=>this.changeType(e)}>
                            <Radio.Button value="1">{Lang({id:"QuanMian",default:"全免"})}</Radio.Button>
                            <Radio.Button value="0">{Lang({id:"YouHuiJinE",default:"优惠金额"})}</Radio.Button>
                        </Radio.Group>
                        {type=="0"&&<div className={"mt_12"}>
                            <InputNumber addonAfter={item.currencySymbol}
                                         precision={2}
                                         min={0.01}
                                         onChange={(value)=>this.changePrice(value)}
                                         placeholder={Lang({id:"QingShuRu",default:"请输入"})} />
                        </div>}
                        <div className={"mt_16 text-right"}>
                            <Button className={"mr_8"} onClick={()=>this.showModal(false)}>{Lang({id: "QuXiao",default: "取消"})}</Button>
                            {isEmpty(type)?<Button type="primary" onClick={()=>this.showModal(false)}>{Lang({id: "QueDing",default: "确定"})}</Button>:<Popconfirm
                                title={Lang({id: "TiShi",default: "提示"})}
                                description={type=="1"?Lang({id: "ShiFouYaoQuanMian",default: "是否要全免？"}):Lang({id: "ShiFouYaoYouHuiJinE",default: "是否要优惠金额？"})}
                                onConfirm={()=>this.handleOK()}
                                // onCancel={()=>this.showModal(false)}
                                okText={Lang({id:'queren',default:'确认'})}
                                cancelText={Lang({id:'QuXiao',default:'取消'})}
                                icon={null}
                            >
                                <Button type="primary">{Lang({id: "QueDing",default: "确定"})}</Button>
                            </Popconfirm>}
                        </div>
                    </div>
                </Spin>
            </EssaModal>
        </>);
    }
}

